const appInfo = {
    title: 'tickety'
};
export default appInfo;

